import React, { useState, useEffect } from 'react'
import AdminHeader from '../../components/Header/AdminHeader'
import AdminSideBar from '../../components/SideBar/AdminSideBar'
import AdminFooter from '../../components/Footer/AdminFooter'
import eventorderStyle from './EventOrdersPage.module.css'
import { DatePicker } from 'rsuite';
import DataTable from 'react-data-table-component';
import { FaMagnifyingGlass } from "react-icons/fa6";
import BackBar from '../../components/BackBar/BackBar';
import { Link } from 'react-router-dom';
import { FiTrash2 } from "react-icons/fi";
import { HiMiniArrowRightEndOnRectangle } from "react-icons/hi2";

export default function EventOrdersPage() {

  const [applyFilters, setApplyFilters] = useState(false);
  const handleSearch = () => {
    setApplyFilters(true);
  };
  const [schoolName, setSchoolName] = useState("");
  const [orderNumber, setOrderNumber] = useState("");
  const [selectedDate, setSelectedDate] = useState('');
  //const [dateFrom, setDateFrom] = useState("");
  //const [dateTo, setDateTo] = useState("");
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [dateRange, setDateRange] = useState([null, null]);
  const [trackingStatus, setTrackingStatus] = useState("");
  const [schools, setSchools] = useState([]);
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // Fetch the data from your PHP API
    const fetchOrders = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_all_orders.php`);
        const data = await response.json();
        if (data.success) {
          setOrders(data.orders);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchOrders();
  }, []);

  useEffect(() => {
    // Fetch the data from your PHP API
    const fetchSchools = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_cordinator_school_data.php?school_flag=ALL`);
        const data = await response.json();
        if (data.success) {
          setSchools(data.users);
          // setFilteredSchools(data.users);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSchools();
  }, []);

  /*const filteredOrders = orders.filter(order => {
    // Convert API date into a valid ISO string
      const orderDate = new Date(order.order_date.replace(" ", "T"));

      // Convert date inputs
      const fromDate = dateFrom ? new Date(dateFrom + "T00:00:00") : null;
      const toDate = dateTo ? new Date(dateTo + "T23:59:59") : null;

      return (
          (schoolName === "" || order.school_name.toLowerCase().includes(schoolName.toLowerCase())) &&
          (orderNumber === "" || order.order_number.toString().includes(orderNumber)) &&
          (trackingStatus === "" || order.tracking_status.toLowerCase().includes(trackingStatus.toLowerCase())) &&
          (!fromDate || orderDate >= fromDate) &&
          (!toDate || orderDate <= toDate)
      );
  }); */

  const getFilteredOrders = () => {
    return orders.filter(order => {
      const orderDate = new Date(order.order_date.replace(" ", "T"));

      return (
        (schoolName === "All" || order.school_name.toLowerCase().includes(schoolName.toLowerCase())) &&
        (orderNumber === "" || order.order_number.toLowerCase().toString().includes(orderNumber.toLowerCase())) &&
        (trackingStatus === "" || order.tracking_status.toLowerCase().includes(trackingStatus.toLowerCase())) &&
        (!dateFrom || orderDate >= dateFrom) &&
        (!dateTo || orderDate <= dateTo)
      );
    });
  };



  const handleDateRangeChange = (value) => {
    setDateRange(value);

    if (value && value[0] && value[1]) {
      const from = new Date(value[0]);
      from.setHours(0, 0, 0, 0);

      const to = new Date(value[1]);
      to.setHours(23, 59, 59, 999);

      setDateFrom(from);
      setDateTo(to);
    } else {
      setDateFrom(null);
      setDateTo(null);
    }
  };





  // DataTable columns configuration
  const columns = [
    {
      name: 'Order Number',
      selector: row => row.order_number,
      sortable: true,
      minWidth: '120px',
      cell: row => (
        <Link to={`/OrderConfirmationPage/${row.order_number}`} className="text-primary">
          {row.order_number}
        </Link>
      ),
    },
    {
      name: 'Order Date',
      selector: row => row.order_date,
      sortable: true,
      minWidth: '180px',
      cell: row => {
        if (!row.order_date) return '';

        const date = new Date(row.order_date.replace(' ', 'T'));
        const formattedDate = date.toLocaleDateString('en-US'); // MM/DD/YYYY
        const formattedTime = date.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        });

        return <p>{formattedDate} {formattedTime}</p>;
      },

      sortFunction: (a, b) => {
        return new Date(a.order_date.replace(' ', 'T'))
          - new Date(b.order_date.replace(' ', 'T'));
      },
    },
    {
      name: 'Close Date',
      selector: row => row.close_date,
      sortable: true,
      minWidth: '180px',
      cell: row => {
        const val = row.close_date;

        // Handle empty / zero date
        if (!val || val === "0000-00-00 00:00:00") {
          return <p>00/00/0000</p>;
        }

        // Convert valid date
        const date = new Date(val.replace(' ', 'T'));
        const formattedDate = date.toLocaleDateString('en-US'); // MM/DD/YYYY
        const formattedTime = date.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        });

        return <p>{formattedDate} {formattedTime}</p>;
      },

      sortFunction: (a, b) => {
        // Treat zero date as earliest
        const dateA = a.close_date === "0000-00-00 00:00:00" ? 0 : new Date(a.close_date.replace(' ', 'T'));
        const dateB = b.close_date === "0000-00-00 00:00:00" ? 0 : new Date(b.close_date.replace(' ', 'T'));
        return dateA - dateB;
      },
    },
    {
      name: 'First Name',
      selector: row => row.first_name,
      sortable: true,
      cell: row => (
        <p>{row.first_name}</p>
      )
    },
    {
      name: 'Last Name',
      selector: row => row.last_name,
      sortable: true,
      cell: row => (
        <p>{row.last_name}</p>
      ),
    },
    {
      name: 'School/Organization Name',
      selector: row => row.school_name,
      sortable: true,
      minWidth: '200px',
      cell: row => (
        <p>{row.school_name}</p>
      ),
    },
    {
      name: 'Event Name',
      selector: row => row.event_name,
      sortable: true,
      minWidth: '200px',
      cell: row => (
        <p>{row.event_name}</p>
      ),
    },
    {
      name: 'Tracking Status',
      selector: row => row.tracking_status,
      sortable: true,
      minWidth: '130px',
      cell: row => (
        <p>{row.tracking_status}</p>
      ),
    },
    {
      name: 'Refund',
      selector: row => row.refund,
      sortable: true,
      minWidth: '120px',
      cell: row => (
        row.refund == 0 ? (
          <Link to={`/OrderRefundPage/${row.order_number}`} className="w-100">
            <button className={`${eventorderStyle.processRefundbtn} btn btn-danger w-100`}>
              Process Refund
            </button>
          </Link>

        ) : (
          <button className={`${eventorderStyle.refundCompletebtn} btn btn-primary w-100`}>
            Refund Complete
          </button>
        )
      ),
    }
  ];

  // Custom styles for the DataTable
  const customStyles = {
    table: {
      style: {
        backgroundColor: '#FFFFFF',
        border: 'none',
        borderRadius: '0px',
        borderCollapse: 'collapse',
        borderSpacing: 0,
        whiteSpace: 'nowrap',
      },
    },
    headRow: {
      style: {
        backgroundColor: '#FFFFFF',
        borderBottom: 'none',
        minHeight: '40px',
        borderCollapse: 'collapse',
        whiteSpace: 'nowrap',
      },
    },
    headCells: {
      style: {
        font: 'normal normal 600 10px/16px Poppins',
        letterSpacing: '0px',
        color: '#707070',
        whiteSpace: 'normal',
        textAlign: 'left',
        padding: '10px 5px',
        border: '1px solid #dee2e6',
        borderCollapse: 'collapse',
        justifyContent: 'center',
        overflow: 'visible',
        whiteSpace: 'nowrap',
      },
    },
    sortIcon: {
      style: {
        position: 'absolute !important',
        right: '8px !important',
        top: '50%',
        transform: 'translateY(-50%)',
      },
    },
    rows: {
      style: {
        minHeight: '32px',
        fontSize: '10px',
        fontFamily: 'Poppins',
        fontWeight: 400,
        borderCollapse: 'collapse',
        color: '#707070',
        '&:not(:last-of-type)': {
          borderBottomStyle: 'none',
        },
      },
    },
    cells: {
      style: {
        font: 'normal normal 400 10px/24px Poppins',
        letterSpacing: '0px',
        color: '#707070',
        whiteSpace: 'normal',
        textAlign: 'left',
        padding: '5px',
        border: '1px solid #dee2e6',
        borderCollapse: 'collapse',
        justifyContent: 'center',
      },
    },
    pagination: {
      style: {
        borderTop: '1px solid #dee2e6',
        paddingTop: '15px',
        font: 'normal normal 400 12px/18px Poppins',
      },
      pageButtonsStyle: {
        color: '#001B64',
        fill: '#001B64',
      },
    },
  };


  return (
    <>
      <AdminHeader />
      <div className={eventorderStyle.eventorderspage} style={{ minHeight: '700px' }}>
        <div className='container'>
          <div className='row mb-4'>
            <div className='col-xl-12'>
              <BackBar />
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-3'>
              <AdminSideBar />
            </div>
            <div className="col-lg-9">
              <div className={eventorderStyle.eventordersBody}>
                <div className={eventorderStyle.eventordersPartone}>
                  <div className="row align-items-center">
                    <div className="col-lg-4">
                      <div className="mb-3 row align-items-center">
                        <label className={`${eventorderStyle.eolabels} col-sm-5 form-label pe-0`}>School Name</label>
                        <div className="col-sm-7">
                          <select className={`${eventorderStyle.eoformSelect} form-select`}
                            value={schoolName}
                            onChange={(e) => setSchoolName(e.target.value)}>
                            <option value="All">All</option>
                            {schools.length > 0 ? (
                              schools.map((school, index) => (
                                <option key={index} value={school.school_name}>{school.school_name}</option>
                              ))
                            ) : (
                              <option value="">-No Data Available-</option>
                            )}
                          </select>
                        </div>
                      </div>
                      <div className="row align-items-center">
                        <label className={`${eventorderStyle.eolabels} col-sm-5 form-label pe-0`}>Order Number</label>
                        <div className="col-sm-7">
                          <input type="text" className={`${eventorderStyle.eoformControl} form-control`} value={orderNumber} onChange={(e) => setOrderNumber(e.target.value)} />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3">

                      <div className="mb-3 row align-items-center">
                        <label className={`${eventorderStyle.eolabels} col-sm-4 form-label pe-0 ${eventorderStyle.maxWidth40}`}>
                          From
                        </label>

                        <div className='col-lg-9'>
                          <DatePicker
                            value={dateFrom}
                            onChange={(value) => {
                              if (value) {
                                const from = new Date(value);
                                from.setHours(0, 0, 0, 0);
                                setDateFrom(from);
                              } else {
                                setDateFrom(null);
                              }
                            }}
                            format="MM/dd/yyyy"
                            placeholder="MM/DD/YYYY"
                            className={eventorderStyle.newdatePickerschol}
                          />
                        </div>
                      </div>
                      <div className="row align-items-center">
                        <label className={`${eventorderStyle.eolabels} col-sm-4 form-label pe-0 ${eventorderStyle.maxWidth40}`}>
                          To
                        </label>

                        <div className='col-lg-9'>
                          <DatePicker
                            value={dateTo}
                            onChange={(value) => {
                              if (value) {
                                const to = new Date(value);
                                to.setHours(23, 59, 59, 999);
                                setDateTo(to);
                              } else {
                                setDateTo(null);
                              }
                            }}
                            format="MM/dd/yyyy"
                            placeholder="MM/DD/YYYY"
                            className={eventorderStyle.newdatePickerschol}
                          />
                        </div>
                      </div>

                      {/* <div className="mb-3 align-items-center row">
                        <label className={`${eventorderStyle.eolabels} col-sm-4 form-label pe-0`}>
                          From
                        </label>

                        <div className='col-lg-6'>
                          <DatePicker
                            value={dateFrom}
                            onChange={(value) => {
                              if (value) {
                                const from = new Date(value);
                                from.setHours(0, 0, 0, 0);
                                setDateFrom(from);
                              } else {
                                setDateFrom(null);
                              }
                            }}
                            format="MM/dd/yyyy"
                            placeholder="MM/DD/YYYY"
                            className={eventorderStyle.newdatePickerschol}
                          />
                        </div>

                        <label className={`${eventorderStyle.eolabels} col-sm-4 form-label pe-0`}>
                          To
                        </label>

                        <div className='col-lg-6'>
                          <DatePicker
                            value={dateTo}
                            onChange={(value) => {
                              if (value) {
                                const to = new Date(value);
                                to.setHours(23, 59, 59, 999);
                                setDateTo(to);
                              } else {
                                setDateTo(null);
                              }
                            }}
                            format="MM/dd/yyyy"
                            placeholder="MM/DD/YYYY"
                            className={eventorderStyle.newdatePickerschol}
                          />
                        </div>
                      </div> */}

                    </div>
                    <div className="col-lg-5">
                      <div className="mb-3 row align-items-center">
                        <label className={`${eventorderStyle.eolabels} col-sm-4 form-label pe-0`}>Tracking Status</label>
                        <div className="col-sm-8">
                          <input type="text" className={`${eventorderStyle.eoformControl} form-control`} value={trackingStatus} onChange={(e) => setTrackingStatus(e.target.value)} />
                        </div>
                      </div>
                      <div className="row align-items-center justify-content-center">
                        <div className="col-sm-12">
                          <button className={`${eventorderStyle.eventSearchbtn} btn btn-primary d-flex justify-content-center align-items-center mx-auto`} onClick={handleSearch} >
                            <FaMagnifyingGlass className={`${eventorderStyle.eventSearchIcon} me-1`} /> Search
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={eventorderStyle.eventordersParttwo}>
                  <DataTable
                    columns={columns}
                    data={applyFilters ? getFilteredOrders() : orders}
                    pagination
                    paginationPerPage={5}
                    paginationRowsPerPageOptions={[5, 10, 15, 20]}
                    highlightOnHover
                    striped
                    responsive
                    customStyles={customStyles}
                    progressPending={isLoading}
                    noDataComponent={<div style={{ padding: '10px', textAlign: 'center', color: '#707070', fontFamily: 'Poppins', fontSize: '12px' }}>No Data Available</div>}
                    sortIcon={<span style={{ paddingLeft: '5px' }}>▼</span>}
                    sortIconRight
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AdminFooter />
    </>
  )
}
